import { Dirary } from '../../types/dirary';
import { SHIFT_TYPE_NORMAL } from '../variables/shift';

//ラジオ体操・朝礼(非生産日報)の判定。createNonProductionDiary(系)が生成する固定の
//製番(99999999)/枝番(99)/工程(605)に一致する明細を表す。夜勤(新規入力)では不要なため、
//夜勤化時にこの明細を除去する(SingleInputHeader/MultiInputHeader の handleShiftToggle/handleFromTimeChange)。
export const isRadioExerciseDiary = (d: Dirary): boolean =>
  d.productNo === '99999999' && d.productBno === '99' && d.processId === '605';

//夜勤(2直)対応: 各ファクトリに shiftType/startTimeText/endTimeText/spansNextDay を追加。
//shiftType は呼出元の現トグル状態を受け取る(省略時は通常0。生成後の再計算で上書きされる)。
//テキスト時刻・日付またぎは生成時は空/false。calcWorkSchedule による再計算で確定値が入る。
export const createDefaultDiary = (
  workerInfo: any,
  workingDate: string,
  fromTime: string,
  toTime: string,
  totalTime: { hour: number; min: number; text: string },
  // hasBreak: boolean,
  productNo: string,
  productBno: string,
  factoryNo: number,
  // construction: number,
  slipNumber: string,
  shiftType: number = SHIFT_TYPE_NORMAL
) => {
  if (workerInfo.workerName === '' || !workerInfo.workerName) {
    return nullADiaryList();
  }
  return {
    id: 0,
    workerId: workerInfo.workerId,
    workerName: workerInfo.workerName,
    departmentId: workerInfo.departmentId,
    affiliationFactoryId: workerInfo.place,
    jobId: workerInfo.jobId,
    workingDate: workingDate,
    factoryId: factoryNo,
    startTime: fromTime,
    endTime: toTime,
    isBreak: false,
    totalWorkingTimeByHour: totalTime.hour,
    totalWorkingTimeByMinute: totalTime.min,
    productNo: productNo,
    productBno: productBno,
    siteName: '未設定',
    processName: '未設定',
    processId: '0000',
    estimatedTime: 0,
    workingTimeByHour: 0.17,
    workingTimeByMinute: 10,
    comment: '',
    slipNumber: slipNumber,
    isSendable: false,
    isDisabled: false,
    itemsNumber: '',
    serialNumber: '',
    soid: '',
    machineNumber: '',
    displayName: '',
    isFinished: '完了',
    shiftType: shiftType,
    startTimeText: '',
    endTimeText: '',
    spansNextDay: false,
  };
};

export const createNonProductionDiary = (
  workerInfo: any,
  workingDate: string,
  fromTime: string,
  toTime: string,
  totalTime: { hour: number; min: number; text: string },
  factoryNo: number,
  shiftType: number = SHIFT_TYPE_NORMAL
) => {
  return {
    id: 0,
    workerId: workerInfo.workerId,
    workerName: workerInfo.workerName,
    departmentId: workerInfo.departmentId,
    affiliationFactoryId: workerInfo.place,
    jobId: workerInfo.jobId,
    workingDate: workingDate,
    factoryId: factoryNo,
    startTime: fromTime,
    endTime: toTime,
    isBreak: false,
    totalWorkingTimeByHour: totalTime.hour,
    totalWorkingTimeByMinute: totalTime.min,
    productNo: '99999999',
    productBno: '99',
    siteName: '',
    processName: 'ラジオ体操・朝礼',
    processId: '605',
    estimatedTime: 0,
    workingTimeByHour: 0.17,
    workingTimeByMinute: 10,
    comment: '',
    slipNumber: '605',
    isSendable: false,
    isDisabled: false,
    itemsNumber: '',
    serialNumber: '',
    soid: '',
    machineNumber: '',
    displayName: '',
    isFinished: '完了',
    shiftType: shiftType,
    startTimeText: '',
    endTimeText: '',
    spansNextDay: false,
  };
};

export const nullADiaryList = (): Dirary => {
  return {
    id: 9999,
    workerId: '',
    workerName: '',
    departmentId: 0,
    affiliationFactoryId: 0,
    jobId: 1,
    workingDate: '',
    factoryId: 0,
    startTime: '',
    endTime: '',
    isBreak: false,
    totalWorkingTimeByHour: 0.17,
    totalWorkingTimeByMinute: 10,
    productNo: '',
    productBno: '',
    siteName: '',
    processName: '',
    processId: '',
    estimatedTime: 0,
    workingTimeByHour: 0.17,
    workingTimeByMinute: 10,
    comment: '',
    slipNumber: '0000000',
    isSendable: false,
    isDisabled: false,
    itemsNumber: '',
    serialNumber: '',
    soid: '',
    machineNumber: '',
    displayName: '',
    isFinished: '完了',
    shiftType: SHIFT_TYPE_NORMAL,
    startTimeText: '',
    endTimeText: '',
    spansNextDay: false,
  };
};

export const createDefaultDiaryForMulti = (
  workingDate: string,
  fromTime: string,
  toTime: string,
  totalTime: { hour: number; min: number; text: string },
  // hasBreak: boolean,
  productNo: string,
  productBno: string,
  factoryNo: number,
  // construction: number,
  slipNumber: string,
  shiftType: number = SHIFT_TYPE_NORMAL
) => {
  return {
    id: 0,
    workerId: '',
    workerName: '',
    departmentId: 0,
    affiliationFactoryId: 0,
    jobId: 1,
    workingDate: workingDate,
    factoryId: factoryNo,
    // constructionId: construction,
    startTime: fromTime,
    endTime: toTime,
    isBreak: false,
    totalWorkingTimeByHour: totalTime.hour,
    totalWorkingTimeByMinute: totalTime.min,
    productNo: productNo,
    productBno: productBno,
    siteName: '未設定',
    processName: '未設定',
    processId: '0000',
    estimatedTime: 0,
    workingTimeByHour: 0.17,
    workingTimeByMinute: 10,
    comment: '',
    slipNumber: slipNumber,
    isSendable: false,
    isDisabled: false,
    itemsNumber: '',
    serialNumber: '',
    soid: '',
    machineNumber: '',
    displayName: '',
    isFinished: '完了',
    shiftType: shiftType,
    startTimeText: '',
    endTimeText: '',
    spansNextDay: false,
  };
};

export const createNonProductionDiaryForMulti = (
  workingDate: string,
  fromTime: string,
  toTime: string,
  totalTime: { hour: number; min: number; text: string },
  factoryNo: number,
  shiftType: number = SHIFT_TYPE_NORMAL
) => {
  return {
    id: 0,
    workerId: '',
    workerName: '',
    departmentId: 0,
    affiliationFactoryId: 0,
    jobId: 1,
    workingDate: workingDate,
    factoryId: factoryNo,
    // constructionId: construction,
    startTime: fromTime,
    endTime: toTime,
    isBreak: false,
    totalWorkingTimeByHour: totalTime.hour,
    totalWorkingTimeByMinute: totalTime.min,
    productNo: '99999999',
    productBno: '99',
    siteName: '',
    processName: 'ラジオ体操・朝礼',
    processId: '605',
    estimatedTime: 0,
    workingTimeByHour: 0.17,
    workingTimeByMinute: 10,
    comment: '',
    slipNumber: '605',
    isSendable: false,
    isDisabled: false,
    itemsNumber: '',
    serialNumber: '',
    soid: '',
    machineNumber: '',
    displayName: '',
    isFinished: '完了',
    shiftType: shiftType,
    startTimeText: '',
    endTimeText: '',
    spansNextDay: false,
  };
};
